import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Button,
  Form,
  Row,
  Col,
  Pagination,
} from "react-bootstrap";
import {
  FiEdit, FiTrash2, FiSearch, FiFile, FiHome,
  FiChevronRight,
} from "react-icons/fi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { getDiaryNote, deletediarynote } from "../../store/slices/diaryNote";


export default function DiaryNote() {
  const dispatch = useDispatch();


  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const [totalData, setTotalData] = useState(0);

  // Fetch diary notes
  const fetchDiaryNotes = () => {
    setIsLoading(true);

    dispatch(getDiaryNote())
      .unwrap()
      .then((res) => {
        setData(res?.data || []);
        setTotalData(res?.totalDataCount || 0);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to fetch diary notes");
        setData([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchDiaryNotes();
  }, []);

  // Delete
  const handleDeleteRow = (id) => {
    if (!window.confirm("Are you sure you want to delete this diary note?"))
      return;

    dispatch(deletediarynote(id))
      .unwrap()
      .then(() => {
        toast.success("Diary note deleted successfully");
        fetchDiaryNotes();
      })
      .catch(() => {
        toast.error("Failed to delete diary note");
      });
  };

  // Pagination

  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>

      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>


            <FiChevronRight className="separator" />

            <span className="active">Diary Notes</span>
          </div>


        </div>
      </div>

      {/* Card */}
      <div className="staff-card">
        <Row className="align-items-center mb-3">
          <Col md={4}>

          </Col>

          <Col md={8} className="staff-tools">
            <div className="staff-search">
              <FiSearch />
              <input placeholder="Search diary note" />
            </div>
          </Col>
        </Row>

        {/* Table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th className="text-center">#</th>
                <th className="text-center">Date</th>
                <th className="text-center">Note</th>
                <th className="text-center">Files</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((item, i) => (
                  <tr key={item._id}>


                    <td className="text-center">{startIndex + i + 1}</td>

                    <td className="text-center">
                      {item?.date ? new Date(item.date).toLocaleDateString() : "-"}
                    </td>

                    <td className="text-center" style={{ maxWidth: "300px" }}>
                      {item.diaryNote}
                    </td>

                    <td className="text-center">
                      {item.files?.length > 0
                        ? item.files.map((file, index) => (
                          <a
                            key={index}
                            href={file}
                            target="_blank"
                            rel="noreferrer"
                            style={{ marginRight: "8px" }}
                          >
                            <FiFile />
                          </a>
                        ))
                        : "-"}
                    </td>

                    <td className="text-center">
                      <FiTrash2
                        onClick={() => handleDeleteRow(item._id)}
                      />

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-3">
                    No diary notes found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              // Show first page, last page, and pages around current page
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              // Left dots
              if (page === currentPage - 2) {
                return <Pagination.Ellipsis key={`left-${page}`} disabled />;
              }

              // Right dots
              if (page === currentPage + 2) {
                return <Pagination.Ellipsis key={`right-${page}`} disabled />;
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />

          </Pagination>
        </div>
      </div>
    </>
  );
}
